import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Link } from '@mui/material';
import { useAuthContext } from '../../auth/useAuthContext';
import { getFormattedImageURL } from '../../utils/helper';
// @mui
// import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

const Logo = forwardRef(  
  ({ disabledLink = false, src = '/logo/NAR-Logo.png', isLoading, sx, ...other }, ref) => {
    // const theme = useTheme();
    const { user, logout } = useAuthContext();  
    const logopath = user?.image;
    // const PRIMARY_LIGHT = theme.palette.primary.light;

    // const PRIMARY_MAIN = theme.palette.primary.main;

    // const PRIMARY_DARK = theme.palette.primary.dark;

    // OR using local (public folder)
    // -------------------------------------------------------
    let logo = (
      <Box
        component="img"
        src={getFormattedImageURL(logopath)}
        sx={{ margin:'auto', cursor: 'pointer', width: "200px", ...sx, objectFit: 'cover' }}
      />
    );
    if(!logopath || logopath===""){
      logo = user?.completeName;
    }
    if(isLoading){
      logo = (
        <Box
          component="img"
          src="/logo/NAR-Logo.png"
          sx={{ margin:'auto', cursor: 'pointer', width: "200px", ...sx, objectFit: 'cover' }}
        />
      );
    }

    
    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} to="/" sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

Logo.propTypes = {
  sx: PropTypes.object,
  src: PropTypes.string,
  disabledLink: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default Logo;
